import * as React from 'react'
import LineGiftIcon from 'LuxKit/Icons/line/LineGiftIcon'
import LineGuidedtoursIcon from 'LuxKit/Icons/line/LineGuidedtoursIcon'
import LineTheatreIcon from 'LuxKit/Icons/line/LineTheatreIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import LineWellnessIcon from 'LuxKit/Icons/line/LineWellnessIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineHotAirBalloonIcon from 'LuxKit/Icons/line/LineHotAirBalloonIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import Label from 'LuxKit/Label/Label'
import { EXP_CATEGORY_LUX_PLUS_ID } from 'constants/experience'
import LineAwardIcon from 'LuxKit/Icons/line/LineAwardIcon'

interface Props {
  categories: Array<App.ExperienceItemCategory>
}

/**
 * Map of parent categoriy ids to the icon for them
 */
const parentCategoryToIconMap: Record<number, React.ReactElement> = {
  // Wine & dining
  1: <LineRestaurantIcon />,
  // Top activities
  9: <LineHotAirBalloonIcon />,
  // Indulge yourself
  31: <LineWellnessIcon />,
  // Attractions & tickets
  18: <LineTicketIcon />,
  // Live events
  27: <LineTheatreIcon />,
  // Airport lounges
  35: <LinePlaneDepartureIcon />,
  // Lux exclusive
  40: <LineStarIcon />,
  // Day tours
  48: <LineGuidedtoursIcon />,
  // Gift Inspiration
  56: <LineGiftIcon />,
  // LuxPlus
  [EXP_CATEGORY_LUX_PLUS_ID]: <LineAwardIcon />,
}

export default function ExperienceCategoryLabel(props: Props) {
  const { categories } = props
  if (!categories?.length) {
    return null
  }

  const category = categories.find(category => category.level === 'parent') ?? categories[0]
  const icon = parentCategoryToIconMap[category?.parentId ?? category.id] ?? <LineStarIcon />

  return <Label kind="secondary" variant="dark" startIcon={icon}>{category.name}</Label>
}
